import { request } from "utils/api";
import { Club } from "./clubs";
import { UserProfile, ReducedUserProfileWithEmail } from "./user";

// login as a dashboard user (POST /auth/dashboard-login)
export const postDashboardLogin = (clubKey: string) => request<{
    club: Club,
    token: string,
}>({
    data: { clubKey },
    endpoint: "/auth/dashboard-login",
    method: "post",
});

// fetch club members for easy login (GET /auth/club-members)
export const getAuthClubMembers = (query: string) => request<ReducedUserProfileWithEmail[]>({
    data: { query },
    endpoint: "/auth/club-members",
    method: "get",
});

// sign up user
export const postSignUp = (firstName: string, lastName: string, clubId?: string) => request<UserProfile>({
    data: { firstName, lastName, clubId },
    endpoint: "/auth/signup",
    method: "post",
});

// request password reset for alias account
export const postAliasAccountPasswordReset = (email: string) => request<{}>({
    data: { email },
    endpoint: "/auth/alias-accounts/reset-password",
    method: "post",
});
